// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropType from 'prop-types';

import {
  assetResolver,
} from '../../utils';

import {
  ButtonContainer,
  ButtonText,
  ButtonIcon,
} from './styles';

const PrimaryNavigationButtonMenu = ({ title, open, onClick }) => (
  <ButtonContainer
    id="ssPrimaryNavigationButtonMenu"
    aria-haspopup="menu"
    aria-expanded={open}
    open={open}
    aria-controls="nav-top"
    onClick={onClick}
  >
    <ButtonText>{title}</ButtonText>
    <ButtonIcon src={assetResolver('down-arrow.svg')} alt="Menu" />
  </ButtonContainer>
);

PrimaryNavigationButtonMenu.propTypes = {
  title: PropType.string,
  open: PropType.bool,
  onClick: PropType.func,
};

PrimaryNavigationButtonMenu.defaultProps = {
  title: null,
  open: false,
  onClick: () => undefined,
};

export default PrimaryNavigationButtonMenu;
